import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 28a1 1 0 0 1-1-1V16a1 1 0 0 1 1-1h6V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10h6a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1zm8-22h5v3a1 1 0 1 0 2 0V6h5v9H10zm5 11h-5v3a1 1 0 1 1-2 0v-3H3v9h12zm2 9h12v-9h-5v3a1 1 0 1 1-2 0v-3h-5z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconMaterialsManagement = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconMaterialsManagement);
export default Memo;
